import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['canvas', 'container'];
  static values = { url: String };

  connect() {
    this.graphInstance = null;
    this.initialized = false;

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.initialized) {
        this.initialized = true;
        this.initializeGraph();
      }
    });
    this.observer.observe(this.element);

    this.filterHandler = (event) => {
      if (this.graphInstance && this.graphInstance.applyFilters) {
        this.graphInstance.applyFilters(event.detail.filters);
      }
    };
    document.addEventListener('icp-universe:filters-changed', this.filterHandler);

    // Listen for org selection from list view or other sources
    this.orgSelectHandler = (event) => {
      if (this.graphInstance && this.graphInstance.selectOrg) {
        this.graphInstance.selectOrg(event.detail.orgId);
      }
    };
    document.addEventListener('icp-universe:org-selected', this.orgSelectHandler);

    // Listen for graph mode changes from the main controller
    this.graphModeHandler = (event) => {
      const { mode } = event.detail;
      if (this.graphInstance && this.graphInstance.setColorMode) {
        this.graphInstance.setColorMode(mode);
      }
      // Toggle legend visibility
      document.querySelectorAll('[data-graph-legend]').forEach((legend) => {
        const isActive = legend.dataset.graphLegend === mode;
        legend.classList.toggle('d-flex', isActive);
        legend.classList.toggle('d-none', !isActive);
      });
    };
    document.addEventListener('icp-universe:graph-mode-changed', this.graphModeHandler);
  }

  async initializeGraph() {
    if (!this.urlValue) return;

    try {
      const module = await import('../pages/icp_universe/graph');
      const createGraph = module.default;
      const initialFilters = this.getFiltersFromUrl();
      const initialOrgId = this.getUrlParam('org');
      const initialColorMode = this.getUrlParam('graph_mode') || 'segment';
      this.graphInstance = createGraph(
        this.canvasTarget,
        this.containerTarget,
        this.urlValue,
        initialFilters,
        initialOrgId,
        initialColorMode
      );
    } catch (error) {
      console.error('Failed to load ICP Universe graph:', error);
    }
  }

  getFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return {
      state: params.get('state') || '',
      segment: params.get('segment') || '',
      discipline: params.get('discipline') || '',
      q: params.get('q') || '',
      tier: params.get('tier') || ''
    };
  }

  getUrlParam(key) {
    return new URLSearchParams(window.location.search).get(key) || '';
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
    document.removeEventListener('icp-universe:filters-changed', this.filterHandler);
    document.removeEventListener('icp-universe:org-selected', this.orgSelectHandler);
    document.removeEventListener('icp-universe:graph-mode-changed', this.graphModeHandler);
    if (this.graphInstance && this.graphInstance.destroy) {
      this.graphInstance.destroy();
      this.graphInstance = null;
    }
  }
}
